export default __webpack_public_path__ + "static/media/messenger.75356672.svg";